import { EnvironmentTypesUnion, LocalesUnion, StorefrontEnvironmentsUnion } from '@ua-okta-ui/schemas'
import { EmailConfig, Locale, SignInViewConfig, StorefrontEnvironment } from '@ua-okta-ui/types'
import { ContextViews } from './enum'
import { WidgetCustomizations } from './global'

export const LOCALES: Locale[] = LocalesUnion.alternatives.map(({ value }) => value)
export const STOREFRONT_ENVIRONMENTS: StorefrontEnvironment[] = StorefrontEnvironmentsUnion.alternatives.map(
	({ value }) => value,
)
export const ENVIRONMENT_TYPES = EnvironmentTypesUnion.alternatives.map(({ value }) => value)

/**
 * These are the form name supported by Terms And Condition logic.
 * If additional form names are needed then add them here.
 */
export const TermsAndConditionsContexts = [
	ContextViews.LOGIN,
	ContextViews.REGISTER,
	ContextViews.RESET_PASSWORD_1,
] as const

export const EMAIL_TEMPLATE_DEFAULTS: EmailConfig & Record<string, unknown> = {
	passcodeOnly: false,
	showShopAppLink: false,

	instagram_link: 'https://www.instagram.com/underarmour/',
	facebook_link: 'https://www.facebook.com/UnderArmour/',
	twitter_link: 'https://x.com/UnderArmour',
	youtube_link: 'https://www.youtube.com/user/underarmour',
}

// The following are handled by the Okta Hosted Widget Engine (Mustache)
export const SIGNIN_VIEW_DEFAULTS: SignInViewConfig = {
	nonceValue: '{{nonceValue}}',
	OktaUtil: '{{{OktaUtil}}}',
	pageTitle: '{{pageTitle}}',
	SignInWidgetResources: '{{{SignInWidgetResources}}}',
	staticRootUrl: '',
}

export const WIDGET_CUSTOMIZATIONS: WidgetCustomizations = {
	classicRecoveryFlowEmailOrUsernameLabel: 'Email or Username',
	customLink1Label: '',
	customLink1Url: '',
	customLink2Label: '',
	customLink2Url: '',
	forgotPasswordLabel: 'Forgot password?',
	forgotPasswordUrl: undefined,
	helpLabel: 'Help',
	helpUrl: '',
	authenticatorPageCustomLinkLabel: '',
	authenticatorPageCustomLinkUrl: '',
	passwordInfoTip: '',
	passwordLabel: 'Password',
	signInLabel: 'Sign In',
	unlockAccountLabel: 'Unlock account?',
	unlockAccountUrl: undefined,
	usernameInfoTip: '',
	usernameLabel: 'Username',
	widgetGeneration: 'G3',
	showPasswordVisibilityToggle: true,
	showUserIdentifier: false,
}

export const WIDGET_VERSION = '7.28'
